// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LMS4-","colBig":"styles_colBig__3-lJp","colSmall":"styles_colSmall__2Hezh"};